"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getFavoriteBlog = void 0;

var _ActionTypes = _interopRequireDefault(require("../ActionTypes"));

var _FavoriteBlog = _interopRequireDefault(require("../../data/model/FavoriteBlog"));

var _constants = require("../../lib/constants");

var getFavoriteBlog = function getFavoriteBlog(state) {
  return state.favoriteBlog;
};

exports.getFavoriteBlog = getFavoriteBlog;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _FavoriteBlog.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_FAVORITE_BLOG_PENDING:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_FAVORITE_BLOG_SUCCEEDED:
      return _FavoriteBlog.default.fromJS(action.data);

    case _ActionTypes.default.FETCH_FAVORITE_BLOG_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    default:
      return state;
  }
};

exports.default = _default;